import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faClockRotateLeft,
    faGear,
    faBan,
    faClipboardList,
    faBuilding,
    faChartPie,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faCircleCheck,
    faCircleXmark,
    faExclamationCircle,
    faExclamationTriangle,
    faGraduationCap,
    faKey,
    faLayerGroup,
    faLock,
    faPen,
    faPencil,
    faPlus,
    faPowerOff,
    faRotateRight,
    faShieldAlt,
    faSignInAlt,
    faSignOutAlt,
    faSitemap,
    faSlidersH,
    faSpinner,
    faTableColumns,
    faTrash,
    faUser,
    faUsers,
    faWallet,
    faBrain,
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faClockRotateLeft,
    faGear,
    faBan,
    faClipboardList,
    faBuilding,
    faChartPie,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faCircleCheck,
    faCircleXmark,
    faExclamationCircle,
    faExclamationTriangle,
    faGraduationCap,
    faKey,
    faLayerGroup,
    faLock,
    faPen,
    faPencil,
    faPlus,
    faPowerOff,
    faRotateRight,
    faShieldAlt,
    faSignInAlt,
    faSignOutAlt,
    faSitemap,
    faSlidersH,
    faSpinner,
    faTableColumns,
    faTrash,
    faUser,
    faUsers,
    faWallet,
    faBrain,
);
